"use client";

import { useAuth } from "@b3dotfun/sdk/global-account/react";
import { createContext, useContext } from "react";

const AuthCookieHintContext = createContext(false);

export function AuthCookieProvider({ value, children }: { value: boolean; children: React.ReactNode }) {
  return <AuthCookieHintContext.Provider value={value}>{children}</AuthCookieHintContext.Provider>;
}

export function useIsAuthenticated(): boolean {
  const { isAuthenticated, isReady } = useAuth();
  const hasAuthCookie = useContext(AuthCookieHintContext);

  if (isReady) return isAuthenticated;
  return hasAuthCookie;
}
